import React from 'react';
import MonitorHealthSection from './monitorHealthSection/MonitorHealthSection';
import RecomendedDoc from './recomendedDoc/RecomendedDoc';
import Layouts from '../../layouts/Layouts';
import HealthDataPlatform from './healthDataPlatform/HealthDataPlatform';
import SignalAITechnologies from './signalAITechnologies/SignalAITechnologies';
import HowOurTechWorks from './howOurTechWorks/HowOurTechWorks';
import {Helmet} from "react-helmet";

function HealthCheck() {
  return (
    <div className='application'>
      <Helmet>
                <meta charSet="utf-8" />
                <meta name='description' content="Testing helmet in merisehat" />
                <meta name="google-site-verification" content="nlrvCzfdn8zrr1DbAneTgvEKW24q9YggciM0x2aNm70" />
                <title>MeriSehat | Test</title>
                <link rel="canonical" href="https://transcendent-souffle-22c9d7.netlify.app/healthCheck" />
            </Helmet>
    <Layouts>
      <section className="healthCheck">
        <MonitorHealthSection />
        <HealthDataPlatform />
        <SignalAITechnologies />
        <HowOurTechWorks />
        <RecomendedDoc />
      </section>
    </Layouts>
    </div>
  );
}

export default HealthCheck;
